<template>
 <v-card
    class="mx-auto"
    max-width="2144"
  >
    <v-img
      :src="img"


    ></v-img>

  </v-card>

</template>

<script setup>
import img from "../assets/img/not_found_moon.png"

</script>
